import React, { useEffect } from 'react';
import { Box } from '@chakra-ui/react';
import ReactECharts from 'echarts-for-react'; // or var ReactECharts = require('echarts-for-react');

const Com = ({ option, styles }: any) => {
  return (
    <ReactECharts
      option={option}
      notMerge={true}
      lazyUpdate={true}
      theme={'theme_name'}
      style={styles}
      // onEvents={EventsDict}
    />
  );
};

export default Com;
